<template>
  	<FlexOnlineSubscriptionReport />
</template>

<script>

// @ is an alias to /src
import FlexOnlineSubscriptionReport from "@/components/reports/Flex/OnlineSubscriptionReport.vue";

export default {
  name: "FlexOnlineSubscriptionReportView",
  components: {
    FlexOnlineSubscriptionReport,
  },
};
</script>
